export const acivityRoutes = [
  {
    name: '烟花年度排行榜',
    path: '/h5/new_years_day',
    component: () => import('./packages/activity/newyear/NewYearRoot.vue'),
  },
  {
    name: '烟花祝福',
    path: '/h5/fireworks_bless',
    component: () => import('./packages/activity/fireworks/NewYearsDayActivity.vue'),
  },
  {
    name: '新年送祝福',
    path: '/h5/new_year',
    component: () => import('./packages/activity/chineseNewyear/ChineseNewYearsDayActivity.vue'),
  },
  {
    name: '喜鹊牌',
    path: '/h5/magpie',
    component: () => import('./packages/activity/magpie/MagpiePage.vue'),
  },
  {
    name: '情人节',
    path: '/h5/valentine',
    component: () => import('./packages/activity/valentine/valentineRank.vue'),
  },
  {
    name: '女神节活动',
    path: '/h5/goddess',
    component: () => import('./packages/activity/goddess/IndexPage.vue'),
  },
  {
    name: '女神节奖励',
    path: '/h5/goddess_reward',
    component: () => import('./packages/activity/goddess/RewardPage.vue'),
  },
  {
    name: '愚人节',
    path: '/h5/fool_day_lottery',
    component: () => import('./packages/activity/foolday/FoolDayLotteryPage.vue'),
  },
  {
    name: '星座活动',
    path: '/h5/constellation',
    component: () => import('./packages/activity/constellation/Index.vue'),
  },
  {
    name: '星座名人殿堂',
    path: '/h5/constellation/hall-of-fame',
    component: () => import('./packages/activity/constellation/HallOfFame.vue'),
  },
  {
    name: '全服榜',
    path: '/h5/whole_rank',
    component: () => import('./packages/activity/wholeRank/WholeRank.vue'),
  },
  {
    name: '贵族神殿',
    path: '/h5/whole_rank/noble_temple',
    component: () => import('./packages/activity/wholeRank/NobleTemple.vue'),
  },
  {
    name: '规则奖励',
    path: '/h5/rank_rule_reward',
    component: () => import('./packages/activity/wholeRank/RuleReward.vue'),
  },
  {
    name: '周星榜',
    path: '/h5/weeklyGiftStarRank',
    component: () => import('./packages/activity/pages/WeeklyGiftStarRank.vue'),
  },
  {
    name: '周星历史榜',
    path: '/h5/weeklyGiftHistoryRank',
    component: () => import('./packages/activity/pages/WeeklyGiftHistoryRank.vue'),
  },
  {
    path: '/h5/song/spring',
    component: () => import('./packages/activity/song/Spring.vue'),
  },
  {
    name: '富豪榜',
    path: '/h5/richrankactivity',
    component: () => import('./packages/activity/halloween/RichRankActivity.vue'),
  },
  {
    name: '富豪榜2',
    path: '/h5/rank/richctivity',
    component: () => import('./packages/activity/halloween2/RichRankActivity.vue'),
  },
  {
    name: '活动结束',
    path: '/h5/activity_end',
    component: () => import('./packages/activity/pages/ActivityEndPage.vue'),
  },
  {
    name: '房间PK',
    path: '/h5/room/pk',
    component: () => import('@/packages/activity/pk/Room.vue'),
  },
  {
    name: '规则',
    path: '/h5/rule',
    component: () => import('@/packages/official/rule/Index.vue'),
  },
  {
    name: '心愿摩天轮',
    path: '/h5/wheel/wish',
    component: () => import('@/packages/feats/wish_wheel/WishFerrisWheelScreen.vue'),
  },
  {
    name: '盲盒小屋',
    path: '/h5/blindboxroom',
    component: () => import('./packages/blindbox/pages/BlindboxRoom.vue'),
  },
  {
    name: 'CP盲盒小屋',
    path: '/h5/cpblindboxroom',
    component: () => import('./packages/blindbox/pages/CPBlindboxRoom.vue'),
  },
  {
    name: '2023年度榜单',
    path: '/h5/yearly_rank_2023',
    component: () => import('./packages/rank_list/yearly/YearlyRankHomeScreen.vue'),
  },
  {
    name: '2023年度榜单奖励',
    path: '/h5/yearly_reward_2023',
    component: () => import('./packages/rank_list/yearly/YearlyRankRewardScreen.vue'),
  },
  {
    name: '龙年盲盒',
    path: '/h5/dragon_blind_box',
    component: () => import('./packages/feats/gifts/dragon/DragonBlindBoxPage.vue'),
  },
  {
    name: 'CP官宣',
    path: '/h5/cp/announce',
    component: () => import('./packages/official/cp/announce/Index.vue'),
  },
  {
    name: 'CP盲盒',
    path: '/h5/cp/blindbox',
    component: () => import('./packages/official/cp/BlindBox.vue'),
  },
  {
    name: '五一劳动节',
    path: '/h5/may_day',
    component: () => import('./packages/activity/may_day/Index.vue'),
  },
  {
    name: '五一劳动节活动规则说明',
    path: '/h5/may_day/rules',
    component: () => import('./packages/activity/may_day/Rules.vue'),
  },
  {
    name: '520活动',
    path: '/h5/520',
    component: () => import('./packages/activity/520/Index.vue'),
  },
  {
    name: '520活动规则说明',
    path: '/h5/520/rules',
    component: () => import('./packages/activity/520/Rules.vue'),
  },
  {
    name: '六一活动',
    path: '/h5/children_day',
    component: () => import('./packages/activity/children_day/Index.vue'),
  },
  {
    name: '六一活动规则页',
    path: '/h5/children_day/rule',
    component: () => import('./packages/activity/children_day/Rule.vue'),
  },
  {
    name: '印象标签规则页',
    path: '/h5/impress_rule',
    component: () => import('./packages/activity/impress_tag/index.vue'),
  },
  {
    name: '极速赛车', //  prams: size=full
    path: '/h5/gold_racing',
    component: () => import('./packages/activity/racing/Index.vue'),
  },
  {
    name: '年度盛典挂件',
    path: '/h5/yearly_pendant',
    component: () => import('./packages/activity/yearly_pendant/Page.vue'),
  },
]

const officialRoutes = [
  {
    name: 'ucoo 赛车代言人',
    path: '/h5/racing_spokesman',
    component: () => import('./packages/activity/racing_battle/IndexPage.vue'),
  },
  {
    name: '官网',
    path: '/',
    component: () => import('./packages/official/home/IndexPage.vue'),
  },
  {
    name: '组件列表',
    path: '/h5/widgets',
    component: () => import('./packages/official/widgets/Index.vue'),
  },
  {
    name: '台湾/海外官网礼品卡移动端',
    path: '/h5/card_client',
    component: () => import('./packages/official/home/cn/CardClient.vue'),
  },
  {
    name: '台湾/海外官网开通vip页',
    path: '/h5/vip',
    component: () => import('./packages/official/home/cn/OpenVipIndex.vue'),
  },
  {
    name: '台湾/海外官网充值页',
    path: '/h5/recharge',
    component: () => import('./packages/official/home/cn/RechargeIndex.vue'),
  },
  // {
  //   name: "高级代理平台登录页",
  //   path: "/agency/login",
  //   component: () => import("./packages/agency/LoginIndex.vue"),
  // },
  // {
  //   name: "高级代理Dashboard",
  //   path: "/agency/dashboard",
  //   component: () => import("./packages/agency/Dashboard.vue"),
  // },
  // {
  //   name: "日区官网充值页",
  //   path: "/h5/recharge_ja",
  //   component: () => import("./packages/official/home/ja/RechargeIndex.vue"),
  // },
  // {
  //   name: "日区主播招募",
  //   path: "/girls/:code?",
  //   component: () => import("./packages/ja/inv/RecruitHomePage.vue"),
  // },
  // {
  //   name: "日区引流主页",
  //   path: "/:code([\\w]{6,10})",
  //   component: () => import("./packages/ja/chat/ChatIndex.vue"),
  // },
  // {
  //   name: "生成URL",
  //   path: "/h5/web_generate",
  //   component: () => import("./packages/official/WebGenerate.vue"),
  // },
  // {
  //   name: "邀请好友",
  //   path: "/h5/intro_invite_friends",
  //   component: () => import("./packages/ja/bonus/BonusIntroV2.vue"),
  // },
  // {
  //   name: "邀请好友2",
  //   path: "/h5/intro_invite_friends_v2",
  //   component: () => import("./packages/ja/bonus/BonusIntroV2.vue"),
  // },
  // {
  //   name: "邀请好友记录",
  //   path: "/h5/record_invite_friends",
  //   component: () => import("./packages/ja/bonus/IndexPage.vue"),
  // },
  // {
  //   name: "下属代理邀请好友记录",
  //   path: "/h5/jp/invite/sub_agent",
  //   component: () => import("./packages/ja/bonus/SubAgentRecord.vue"),
  // },
  // {
  //   name: "工资结算",
  //   path: "/h5/salary_settlement",
  //   component: () => import("./packages/official/settlement/IndexPage.vue"),
  // },
  // //主播招募
  // {
  //   path: "/h5/page_recruit",
  //   component: () => import("./packages/official/AnchorRecruitPage.vue"),
  // },
  {
    path: '/h5/tool_dataurl_convert',
    component: () => import('./packages/tools/DataUrlTool.vue'),
  },
  {
    name: '强制升级',
    path: '/h5/force_upgrade',
    component: () => import('./packages/official/ForceUpgradeDialog.vue'),
  },
  {
    name: '真人认证提示',
    path: '/h5/reality_alert',
    component: () => import('./packages/official/RealityAlertDialog.vue'),
  },
  {
    name: '主播行为规范',
    path: '/h5/anchor_behavior',
    component: () => import('./packages/official/behavior/IndexPage.vue'),
  },
  {
    name: '主播与公会协议',
    path: '/h5/anchor_union_agreement',
    component: () => import('./packages/official/union/IndexPage.vue'),
  },
  {
    name: '社群指南',
    path: '/h5/rule/community',
    component: () => import('./packages/official/rule/Community.vue'),
  },
  {
    name: '主播认证提示',
    path: '/h5/auth_alert',
    component: () => import('./packages/official/auth/IndexPage.vue'),
  },
  {
    name: '乙方与乙方人员承诺函',
    path: '/h5/promise_page',
    component: () => import('./packages/official/register/PromisePage.vue'),
  },
  {
    name: '主播注册信息表',
    path: '/h5/register_info_table',
    component: () => import('./packages/official/register/RegisterInfoPage.vue'),
  },
  {
    name: '主播等级',
    path: '/h5/anchor_rating',
    component: () => import('./packages/level/anchor/AnchorRatingPage.vue'),
  },
  {
    name: '主播问答',
    path: '/h5/question',
    component: () => import('./packages/exam/QuestionList.vue'),
  },
  {
    name: '新主播问答提现',
    path: '/h5/new/question',
    component: () => import('./packages/exam/NewQuestionList.vue'),
  },
  {
    name: '充值协议',
    path: '/h5/charge',
    component: () => import('./packages/official/charge/IndexPage.vue'),
  },
  {
    name: '隐私政策',
    path: '/h5/privacy',
    component: () => import('./packages/official/privacy/IndexPage.vue'),
  },
  {
    name: '承诺函',
    path: '/h5/promise',
    component: () => import('./packages/agreement/pages/PromiseAgreement.vue'),
  },
  {
    name: '主播协议',
    path: '/h5/broadcaster_agreement',
    component: () => import('./packages/official/broadcaster/IndexPage.vue'),
  },
  {
    name: '用户协议',
    path: '/h5/agreement',
    component: () => import('./packages/official/agreement/IndexPage.vue'),
  },
  {
    name: '翻译工具',
    path: '/h5/translate',
    component: () => import('./packages/tools/TranslatePage.vue'),
  },
  {
    name: '新主播任务实验',
    path: '/h5/new_anchor_v4',
    component: () => import('./packages/newbieAnchorTask/NewAnchorTaskV4.vue'),
  },
  {
    name: '新主播任务',
    path: '/h5/new_anchor_v3',
    component: () => import('./packages/newbieAnchorTask/NewAnchorTaskV3.vue'),
  },
  {
    name: '组cp任务攻略',
    path: '/h5/cp_task_guide',
    component: () => import('./packages/newbieAnchorTask/CpTaskGuide.vue'),
  },
  {
    name: '聊天任务攻略',
    path: '/h5/chat_task_guide',
    component: () => import('./packages/newbieAnchorTask/ChatTaskGuide.vue'),
  },
  {
    name: '语音匹配积分说明',
    path: '/h5/audio_match_doc',
    component: () => import('./packages/official/AudioMatchDoc.vue'),
  },
  {
    name: '视频匹配积分说明',
    path: '/h5/video_match_doc',
    component: () => import('./packages/official/VideoMatchDoc.vue'),
  },
  {
    name: '新人流量推荐规则',
    path: '/h5/newer_recom_rule',
    component: () => import('./packages/official/NewerRemRule.vue'),
  },

  {
    name: '产品介绍',
    path: '/h5/page_introduce',
    component: () => import('./packages/official/IntroducePage.vue'),
  },
  {
    name: '愚人节房间',
    path: '/h5/april_fools_day_rooms',
    component: () => import('./packages/official/AprilFoolsDayRooms.vue'),
  },
  { path: '/h5/about', component: { template: '<div>Second Page</div>' } },
  {
    name: '我的等级',
    path: '/h5/mine_level',
    component: () => import('./packages/level/MineLevel.vue'),
  },
  {
    name: '虚拟女友资料',
    path: '/h5/broadcaster/virtualgfprofile',
    component: () => import('./packages/broadcaster/pages/VirtualGFProfile.vue'),
  },
  {
    name: '客服中心',
    path: '/h5/customerservice',
    component: () => import('./packages/customerservice/index.vue'),
  },
  {
    name: '协议编辑',
    path: '/h5/edit_agreement',
    component: () => import('./packages/tools/EditAgreement.vue'),
  },
  {
    name: '提现',
    path: '/h5/withdraw',
    component: () => import('@/packages/official/withdraw/Index.vue'),
  },
  {
    name: '网页提现',
    path: '/h5/withdraw/web',
    component: () => import('@/packages/official/withdraw/Withdraw.vue'),
  },
  {
    name: '兑换指引',
    path: '/h5/exchange',
    component: () => import('@/packages/official/withdraw/Exchange.vue'),
  },
  {
    path: '/h5/withdraw/confirm',
    component: () => import('@/packages/official/withdraw/Confirm.vue'),
  },
  {
    path: '/h5/withdraw/confirm/web',
    component: () => import('@/packages/official/withdraw/ConfirmWeb.vue'),
  },
  {
    path: '/h5/alipay/account',
    component: () => import('@/packages/official/pay/Account.vue'),
  },
  {
    path: '/h5/alipay/account/web',
    component: () => import('@/packages/official/pay/AccountWeb.vue'),
  },
  {
    path: '/h5/credit_transaction',
    component: () => import('@/packages/official/credit/Index.vue'),
  },
  {
    name: '优惠充值',
    path: '/h5/discount_recharge',
    component: () => import('@/packages/official/recharge/Index.vue'),
  },
  {
    name: '实名认证',
    path: '/h5/auth',
    component: () => import('./packages/official/auth/Index.vue'),
  },
  {
    name: '贵族系统',
    path: '/h5/noble',
    component: () => import('@/packages/official/noble/Index.vue'),
  },
  {
    name: '贵族说明',
    path: '/h5/noble_introduce',
    component: () => import('./packages/noble/IndexPage.vue'),
  },
  {
    name: '贵族成长值',
    path: '/h5/noble_growth',
    component: () => import('./packages/noble/GrowthRecordPage.vue'),
  },
  {
    name: '魅力殿堂',
    path: '/h5/rank/charm',
    component: () => import('./packages/official/rank/charm/Index.vue'),
  },
  {
    name: '官宣CP',
    path: '/h5/cp/show',
    component: () => import('./packages/official/cp/show/Index.vue'),
  },
  {
    name: '登录页',
    path: '/h5/login',
    component: () => import('./packages/official/login/Index.vue'),
  },
  // { path: '/:init(.*)*', component: () => import('./App.vue') },
]

const devRoutes = [
  {
    path: '/h5/list',
    component: () => import('./packages/feats/PageList.vue'),
  },
  {
    path: '/h5/iframe',
    component: () => import('./packages/feats/Iframes.vue'),
  },
  {
    path: '/h5/hello',
    component: () => import('./components/HelloWorld.vue'),
  },
  {
    path: '/h5/test',
    component: () => import('./components/test.vue'),
  },
]

export const ucooRoutes = [
  {
    name: 'ucoo 跨年',
    path: '/h5/newyear',
    component: () => import('./packages/activity/goddess/old/Index.vue'),
  },
  {
    name: 'ucoo 春节活动来舞会',
    path: '/h5/springfestival',
    component: () => import('./packages/activity/dance/springfestial/Index.vue'),
  },
  {
    name: 'ucoo 春节活动来舞会撒糖页面',
    path: '/h5/springfestival_candy',
    component: () => import('./packages/activity/dance/springfestial/SendCandy.vue'),
  },
  {
    name: 'ucoo 元气挑战赛',
    path: '/h5/energy_challenge',
    component: () => import('./packages/activity/rank/energy/Index.vue'),
  },
  {
    name: 'ucoo 情人节跳舞活动',
    path: '/h5/valentinesday',
    component: () => import('./packages/activity/dance/valentinesday/Index.vue'),
  },
  {
    name: 'ucoo 情人节跳舞活动 -内链- 撒糖',
    path: '/h5/valentinesday_candy',
    component: () => import('./packages/activity/dance/valentinesday/SendCandy.vue'),
  },
  {
    name: 'ucoo 女神节',
    path: '/h5/old/goddess',
    component: () => import('./packages/activity/goddess/old/GodnessPage.vue'),
  },
  {
    name: 'ucoo 愚人节跳舞活动',
    path: '/h5/dance/aprilfoolday',
    component: () => import('@/packages/activity/dance/aprilfoolday/Index.vue'),
  },
  {
    name: 'ucoo 愚人节跳舞活动 -内链- 撒糖',
    path: '/h5/aprilfoolday_candy',
    component: () => import('./packages/activity/dance/aprilfoolday/components/SendCandy.vue'),
  },
  {
    name: 'ucoo 520',
    path: '/h5/cp_rank_520',
    component: () => import('./packages/activity/activity520/RankPage.vue'),
  },
  {
    name: 'ucoo 520 礼物墙',
    path: '/h5/giftwall520',
    component: () => import('./packages/activity/activity520/GiftWall.vue'),
  },
  {
    name: 'ucoo 520 表白墙',
    path: '/h5/vindicate520',
    component: () => import('./packages/activity/activity520/MainPage.vue'),
  },
  {
    path: '/h5/springSongActivity2403',
    component: () => import('./packages/activity/springsong2403/SpringSongActivity2403.vue'),
  },
  {
    name: 'ucoo 夏日歌会',
    path: '/h5/song/summer',
    component: () => import('./packages/activity/song/summer/Index.vue'),
  },
  {
    name: '七夕活动',
    path: '/h5/activity_qixi',
    component: () => import('./packages/activity/activity77/IndexPage.vue'),
  },
  {
    name: 'ucoo 中秋活动',
    path: '/h5/mid_autumn',
    component: () => import('./packages/activity/reward/mid_autumn/Index.vue'),
  },
  {
    name: 'ucoo 万圣节',
    path: '/h5/halloween',
    component: () => import('./packages/activity/song/halloween/Index.vue'),
  },
  {
    name: 'ucoo 赛车代言人',
    path: '/h5/racing_spokesman',
    component: () => import('./packages/activity/racing_battle/IndexPage.vue'),
  },
  {
    name: 'ucoo 极速赛车 prams: size=full',
    path: '/h5/gold_racing',
    component: () => import('./packages/activity/racing/Index.vue'),
  },
  {
    name: 'ucoo 全球匿名信',
    path: '/h5/letters',
    component: () => import('./packages/activity/letters/MainPage.vue'),
  },
  {
    name: 'ucoo 我的信箱',
    path: '/h5/mailbox',
    component: () => import('./packages/activity/letters/LettersBox.vue'),
  },
  {
    name: 'ucoo 魅力主播大作战',
    path: '/h5/dragon_wish_reward',
    component: () => import('./packages/activity/anchor_fight/MainActivity.vue'),
  },
  {
    name: 'ucoo 无效',
    path: '/h5/dialogpreview',
    component: () => import('./packages/activity/dragonbaby/dialog/DialogPreview.vue'),
  },
  {
    name: 'ucoo 龙年祈愿',
    path: '/h5/acivity/dragon_wish_reward',
    component: () => import('./packages/activity/dragonwish/DragonWishReward.vue'),
  },
  {
    name: 'ucoo 龙年限定礼物墙',
    path: '/h5/gift_wall/dragon_year_limited',
    component: () => import('./packages/feats/gifts/dragon/DragonWallRootView.vue'),
  },
  {
    name: 'ucoo 龙宝养成计划',
    path: '/h5/activity/dragon_baby',
    component: () => import('./packages/activity/dragonbaby/DragonBaby.vue'),
  },
  {
    name: 'ucoo 龙宝宝箱奖励图鉴',
    path: '/h5/activity/dragon_reward',
    component: () => import('./packages/activity/dragonbaby/DragonReward.vue'),
  },
  {
    name: 'ucoo 心愿摩天轮',
    path: '/h5/wish_ferris_wheel',
    component: () => import('./packages/feats/wish_wheel/WishFerrisWheelScreen.vue'),
  },
  {
    name: 'ucoo 银币狂欢节',
    path: '/h5/silvercoincarnival',
    component: () => import('./packages/activity/pages/SilverCoinCarnival202401.vue'),
  },
  {
    name: 'ucoo 玲龙 公会赞助',
    path: '/h5/nicelinglong',
    component: () => import('./packages/activity/pages/NiceLingLong202401.vue'),
  },
  {
    path: '/h5/old/constellation',
    component: () => import('./packages/activity/constellationold/MainPage.vue'),
  },
  {
    name: '挑战规则',
    path: '/h5/old/constellation/challenge/rule',
    component: () => import('./packages/activity/constellationold/ChallengeRule.vue'),
  },
  {
    name: '刮刮乐',
    path: '/h5/guaguale',
    component: () => import('./packages/feats/guaguale/IndexPage.vue'),
  },
  {
    path: '/h5/ggl_rule',
    component: () => import('./packages/feats/guaguale/GGLRule.vue'),
  },
  {
    path: '/h5/record_ggl',
    component: () => import('./packages/feats/guaguale/RecordListPage.vue'),
  },
]

// 获取所有路由
const views = import.meta.glob('./packages/**/**/router.ts', {
  eager: true,
  import: 'default',
})
const dynamicRoutes = Object.keys(views)
  .reduce((routes, key) => [].concat(routes, views[key]), [])
  .flat(1)
  .filter(route => {
    if (route && route.meta && route.meta.expire) {
      const { expire, keepTime = 7 * 24 * 60 * 60 * 1000 } = route.meta
      return new Date(expire).getTime() + keepTime > Date.now()
    }
    return true
  })

export const routes = [
  ...dynamicRoutes,
  ...officialRoutes,
  ...acivityRoutes,
  ...(import.meta.env.MODE === 'development' ? ucooRoutes : []),
  ...(import.meta.env.MODE === 'development' ? devRoutes : []),
]
